import axios from 'axios';
import { objectToFormData } from 'object-to-formdata';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Field, reduxForm, getFormValues, SubmissionError } from 'redux-form';
import { RenderFileUpload, RenderHTMLSelect, RenderInputWithDiv, RenderDatePicker } from '../../component/formInput';
import AlertLabel from '../../component/AlertLabel';
import { isArray } from 'lodash';
import BlockUI from '../../component/BlockUI';
import { genders } from '../../models/genders';
import { countries } from '../../models/countries';
import { cities } from '../../models/cities';
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var _ = require('lodash');

function UpdatePersonalProfileField(updateField, key, data) {
  updateField(key + "id", data.id); 
  updateField(key + "full_name", data.full_name);
  updateField(key + "gender", data.gender);
  updateField(key + "birthday", data.birthday);
  updateField(key + "id_number", data.id_number);
  updateField(key + "nation", data.nation);
  updateField(key + "city", data.city);
  updateField(key + "address", data.address);
  updateField(key + "phone", data.phone);
  updateField(key + "email", data.email);
}

function PersonalTitleInner (key_name) {
  let inner_personal_type_html =  
      <div style={{ borderBottom: "1px solid" }} className="text-left">
        <span style={{ color: 'orange' }}>THÔNG TIN CÁ NHÂN</span>
      </div>
  if(key_name === "manager_") {
    inner_personal_type_html = 
      <div style={{ borderBottom: "1px solid" }} className="text-left">
        <span style={{ color: 'orange' }}>NGƯỜI QUẢN LÝ TÊN MIỀN</span>
      </div>
  }
  if(key_name === "tech_") {
    inner_personal_type_html = 
      <div style={{ borderBottom: "1px solid" }} className="text-left">
        <span style={{ color: 'orange' }}>NGƯỜI QUẢN LÝ KỸ THUẬT</span>
      </div>
  }
  if(key_name === "pay_") {
    inner_personal_type_html = 
      <div style={{ borderBottom: "1px solid" }} className="text-left">
        <span style={{ color: 'orange' }}>NGƯỜI THANH TOÁN</span>
      </div>
  }
  if(key_name === "rep_") {
    inner_personal_type_html = 
      <div style={{ borderBottom: "1px solid" }} className="text-left">
        <span style={{ color: 'orange' }}>NGƯỜI THAY MẶT CƠ QUAN LÀM THỦ TỤC ĐĂNG KÝ TÊN MIỀN</span>
      </div>
  }
  return inner_personal_type_html;
}

class PersonalProfileForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }

  render() {
    const { image_1, image_2 ,parent_profile, onPreviewImg, key_name, is_main_personal_profile, handleFillDataFromManager } = this.props;
    return (
      <fieldset>
        <br/>
        {PersonalTitleInner(key_name)}
        <br/>
        {!is_main_personal_profile && key_name != "manager_" && <div className="col-form-label col-lg-9">
          <a onClick={() => handleFillDataFromManager(key_name)} style={{ cursor: "pointer",color:'blue' }}>Lấy thông tin người quản lý tên miền</a>
        </div>}
        <Field
          name={key_name + "full_name"}
          type="text"
          placeholder="Vui lòng tiếng Việt có dấu"
          component={RenderInputWithDiv}
          required
          label="Họ và tên chủ thể"/>

        <Field
          name={key_name + "gender"}
          options={genders}
          component={RenderHTMLSelect}
          required
          label="Giới tính"/>

        <Field
          name={key_name + "birthday"}
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          component={RenderDatePicker}
          label="Ngày sinh"/>

        <Field
          name={key_name + "id_number"}
          type="text"
          component={RenderInputWithDiv}
          required
          label="Số CMND"/>

        <Field
          name={key_name + "nation"}
          options={countries}
          component={RenderHTMLSelect}
          required
          label="Quốc gia"/>

        <Field
          name={key_name + "city"}
          options={cities}
          component={RenderHTMLSelect}
          required
          label="Tỉnh thành / thành phố"/>

        <Field
          name={key_name + "address"}
          type="text"
          component={RenderInputWithDiv}
          required
          label="Địa chỉ"/>

        <Field
          name={key_name + "phone"}
          type="text"
          component={RenderInputWithDiv}
          required
          label="Điện thoại"/>

        <Field
          name={key_name + "email"}
          type="text"
          component={RenderInputWithDiv}
          required
          label="Email"/>
        {is_main_personal_profile && 
          <React.Fragment>
            <Field
              name="file_upload_1"
              label="CMND mặt trước"
              fileAccept = "image/*"
              defaultValue = {parent_profile.image_1}
              height = {85}
              width = {250}
              is_preview={true}
              onChangeAction={(value)=> onPreviewImg(URL.createObjectURL(value[0]), image_2)}
              component={RenderFileUpload}
            />
            <Field
              name="file_upload_2"
              label="CMND mặt sau"
              fileAccept = "image/*"
              defaultValue = {parent_profile.image_2}
              height = {85}
              width = {250}
              is_preview={true}
              onChangeAction={(value)=> onPreviewImg(image_1, URL.createObjectURL(value[0]))}
              component={RenderFileUpload}
            />
          </React.Fragment>}
      </fieldset>
    )
  }
}

class CompanyProfileForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }

  componentDidMount() {
    const { updateField, sub_profiles } = this.props;
    sub_profiles && _.forEach(sub_profiles, function (i) {
      if(i.type === "MANAGE" ) {
        UpdatePersonalProfileField(updateField, "manager_", i);
      }
      if(i.type === "TECH") {
        UpdatePersonalProfileField(updateField, "tech_", i);
      }
      if(i.type === "PAY") {
        UpdatePersonalProfileField(updateField, "pay_", i);
      }
      if(i.type === "REP") {
        UpdatePersonalProfileField(updateField, "rep_", i);
      }
    })
  }

  // Sử dụng lại thông tin của người quản lý tên miền
  handleFillDataFromManager = (key) => {
    const { updateField, form_value } = this.props;
    // Đổ dữ liệu vào các Field
    // Chú thích: key ở đây để xác định các ô nhập theo chức vụ VD: tech_ , pay_ , rep_  
    updateField(key + "full_name", form_value.manager_full_name);
    updateField(key + "gender", form_value.manager_gender);
    updateField(key + "birthday", form_value.manager_birthday);
    updateField(key + "id_number", form_value.manager_id_number);
    updateField(key + "nation", form_value.manager_nation);
    updateField(key + "city", form_value.manager_city);
    updateField(key + "address", form_value.manager_address);
    updateField(key + "phone", form_value.manager_phone);
    updateField(key + "email", form_value.manager_email);
  }

  render() {
    const { image_1, image_2 ,parent_profile, onPreviewImg, key_name } = this.props;
    const key_name_list = ["manager_" , "tech_", "pay_", "rep_" ];
    const sub_personal_form = _.map(key_name_list, (i, index) => <PersonalProfileForm 
      handleFillDataFromManager = {this.handleFillDataFromManager}
      key={index}
      key_name={i}
      image_1 = {image_1} 
      image_2 = {image_2} 
      onPreviewImg = {this.onPreviewImg}/> 
    )

    return (
      <React.Fragment>
        <br/>
        <div style={{ borderBottom: "1px solid" }} className="text-left">
          <span style={{ color: 'orange' }}>THÔNG TIN DOANH NGHIỆP</span>
        </div>
        <br/>
        <fieldset>
          <Field
            name="full_name"
            placeholder="Vui lòng tiếng Việt có dấu"
            component={RenderInputWithDiv}
            label="Họ và tên chủ thể"/>

          <Field
            name="inter_name"
            placeholder="Nhập tên giao dịch quốc tế (nếu có)"
            component={RenderInputWithDiv}
            label="Tên giao dịch quốc tế"/>

          <Field
            name="vat_no"
            component={RenderInputWithDiv}
            label="Mã số thuế"/>

          <Field
            name="address"
            component={RenderInputWithDiv}
            label="Địa chỉ"/>

          <Field
            name="nation"
            options={countries}
            component={RenderHTMLSelect}
            required
            label="Quốc gia"/>

          <Field
            name="city"
            options={cities}
            component={RenderHTMLSelect}
            required
            label="Tỉnh thành / thành phố"/>

          <Field
            name="phone"
            component={RenderInputWithDiv}
            label="Điện thoại / Fax"/>

          <Field
            name="email"
            component={RenderInputWithDiv}
            label="Email"/>
          <Field
            name="company_file"
            label="Giấy phép kinh doanh"
            fileAccept = "image/*"
            defaultValue = {parent_profile.image_1}
            height = {85}
            width = {250}
            is_preview={true}
            onChangeAction={(value)=> onPreviewImg(URL.createObjectURL(value[0]), null)} 
            component={RenderFileUpload}
          />
        </fieldset>
        {sub_personal_form}
      </React.Fragment>
    )
  }
}

class EditDomainProfileForm extends React.Component {
  constructor(props) {
    super(props);
    this.state={
       alert_label: null,
       is_loading: false
    }
  }
  
  componentDidMount() { 
    const self = this;
    const { domain_profile_id } = this.props.match.params;
    const { loadDomainProfileAsync } = this.props;
    loadDomainProfileAsync(domain_profile_id);
  }

  componentWillUnmount() {
    const { clearDomainProfileValue } = this.props;
    clearDomainProfileValue();
  }
 
  updatePersonalDomainProfile = (values) => {
    this.setState({
      is_loading: true
    })
    const self = this;
    const data_value =  {
      id: values.id,
      full_name: values.full_name,
      default_profile: false,
      gender: values.gender,
      birthday: moment(values.birthday).format("YYYY-MM-DD"),
      id_number: values.id_number,
      nation: values.nation,
      city: values.city,
      address: values.address,
      phone: values.phone,
      email: values.email,
      inter_name: null,
      vat_no: values.vat_no,
      file_upload_1: values.file_upload_1 && values.file_upload_1[0],
      file_upload_2: values.file_upload_2 && values.file_upload_2[0],
    }
    // convert Object to FormData
    const formData = objectToFormData(data_value);

    return axios({
      method: 'post',
      url: window.api_url + "/api/user/domain/profile/personal/update",
      data: formData,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        is_loading: false
      })
      if(!response.data.isError){
        toast.success("Cập nhật bản khai thành công !.");
      }else {
        toast.error("Có lỗi trong quá trình lưu trữ, vui lòng kiểm tra lại dữ liệu !");
        throw new SubmissionError(response.data.error)
      }
    });
  }

  updateCompanyDomainProfile = (values) => {
    this.setState({
      is_loading: true
    })
    const self = this;
    const data_value = {
      id: values.id,
      full_name: values.full_name,
      is_company: true, // set true for profile type company
      default_profile: false,
      gender: null,
      birthday: null,
      id_number: null,
      nation: values.nation,
      city: values.city,
      address: values.address,
      phone: values.phone,
      email: values.email,
      inter_name: values.inter_name,
      vat_no: values.vat_no,
      company_file: values.company_file && values.company_file[0],

      manager_id: values.manager_id,
      manager_full_name: values.manager_full_name,
      manager_gender: values.manager_gender,
      manager_birthday: moment(values.manager_birthday).format("YYYY-MM-DD"),
      manager_id_number: values.manager_id_number,
      manager_nation: values.manager_nation,
      manager_city: values.manager_city,
      manager_address: values.manager_address,
      manager_phone: values.manager_phone,
      manager_email: values.manager_email,

      tech_id: values.tech_id,
      tech_full_name: values.tech_full_name,
      tech_gender: values.tech_gender,
      tech_birthday: moment(values.tech_birthday).format("YYYY-MM-DD"),
      tech_id_number: values.tech_id_number,
      tech_nation: values.tech_nation,
      tech_city: values.tech_city,
      tech_address: values.tech_address,
      tech_phone: values.tech_phone,
      tech_email: values.tech_email,

      pay_id: values.pay_id,
      pay_full_name: values.pay_full_name,
      pay_gender: values.pay_gender,
      pay_birthday: moment(values.pay_birthday).format("YYYY-MM-DD"),
      pay_id_number: values.pay_id_number,
      pay_nation: values.pay_nation,
      pay_city: values.pay_city,
      pay_address: values.pay_address,
      pay_phone: values.pay_phone,
      pay_email: values.pay_email,

      rep_id: values.rep_id,
      rep_full_name: values.rep_full_name,
      rep_gender: values.rep_gender,
      rep_birthday:  moment(values.rep_birthday).format("YYYY-MM-DD"),
      rep_id_number: values.rep_id_number,
      rep_nation: values.rep_nation,
      rep_city: values.rep_city,
      rep_address: values.rep_address,
      rep_phone: values.rep_phone,
      rep_email: values.rep_email,
    }

    const formData = objectToFormData(data_value);

    return axios({
      method: 'post',
      url: window.api_url + "/api/user/domain/profile/company/update",
      data: formData,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        is_loading: false
      })
      if(!response.data.isError){
        toast.success("Cập nhật bản khai thành công !.");
      }else {        
        toast.error("Có lỗi trong quá trình lưu trữ, vui lòng kiểm tra lại dữ liệu !")
        throw new SubmissionError(response.data.error)
      }
    })
  }
  
  onPreviewImg = (image_1, image_2) => {
    this.setState({
      image_1: image_1,
      image_2: image_2,
    })
  }

  render() {
    const { handleSubmit, submitting, parent_profile, sub_profiles} = this.props;
    const { alert_label, image_1, image_2, is_loading} = this.state;
    return (
      <React.Fragment>
        {is_loading && <BlockUI/>}
        {parent_profile && <div className="content">
          <ToastContainer />
          <div className="row">
            <h4>
              <i className="icon-paragraph-justify2 mr-2"></i>
              <span className="text-semibold">Chỉnh sửa bản khai</span>
            </h4>
          </div>
          <div className="card" style={{ backgroundColor:'white' }} >
            {alert_label && <AlertLabel status = {alert_label.status} message = {alert_label.message}/>}
            <form onSubmit={handleSubmit(parent_profile.is_company ? this.updateCompanyDomainProfile : this.updatePersonalDomainProfile)}>
              <div style={{margin:20}} className="form-group">
                {!parent_profile.is_company && <PersonalProfileForm 
                  key_name={""}
                  is_main_personal_profile={true}
                  image_1 = {image_1} 
                  image_2 = {image_2} 
                  parent_profile = {parent_profile} 
                  onPreviewImg = {this.onPreviewImg} 
                  />}
                {parent_profile.is_company && <CompanyProfileFormWrapper 
                  sub_profiles = {sub_profiles}
                  image_1 = {image_1} 
                  parent_profile = {parent_profile} 
                  onPreviewImg = {this.onPreviewImg} 
                  />}
              </div>
              <div className="modal-footer">
                <button href="#" type="submit" className={"btn bg-primary"}>
                  Cập Nhật
                </button>
              </div>
            </form>
          </div>
      </div>}
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  initialValues: {
    ...state.customerData.parent_profile
  },
  parent_profile: state.customerData.parent_profile,
  sub_profiles: state.customerData.sub_profiles,
  form_value: getFormValues("EditDomainProfileForm")(state) // get all value from MainPersonal

});

const mapDispatch = (dispatch) => ({
  loadDomainProfileAsync: (domain_profile_id) => dispatch.customerData.loadDomainProfileAsync(domain_profile_id),
  clearDomainProfileValue: () => dispatch.customerData.clearDomainProfileValue(),
  updateField: (fieldName, value) =>
    dispatch({
      meta: { form: "EditDomainProfileForm", field: fieldName },
      payload: value,
      type: "@@redux-form/CHANGE"
    }),
});

const EditDomainProfileFormWrapper = reduxForm({
  form: 'EditDomainProfileForm',
  destroyOnUnmount: true,
  enableReinitialize: true
})(EditDomainProfileForm);

const CompanyProfileFormWrapper = (connect(mapState, mapDispatch)(CompanyProfileForm));

export default connect(mapState, mapDispatch)(withRouter(EditDomainProfileFormWrapper));